import { post } from "../../network/endpoint";
import * as ActionTypes from "services/state/action-types";
import { success } from "services/utils/action";
import { normalizeServiceRequest } from "./helpers";

export function postScheduling(
  values,
  { requestId, serviceOrder },
  customer,
  callback
) {
  return (dispatch) => {
    const config = {
      pathValues: { orderId: requestId },
      data: normalizeServiceRequest(values, requestId, serviceOrder, customer),
    };
    const request = post("osRescheduling", config);

    dispatch({
      type: ActionTypes.SEND_RESCHEDULING,
      payload: request,
    }).then(success(callback));
  };
}



// WEBPACK FOOTER //
// ./src/services/state/rescheduling/action.js